import { createRouter, createWebHistory } from 'vue-router';
import { configs } from '@/shared/configs';
import { storageService } from '@/shared/services/storageService';
import { AuthCallback } from '@/components/AuthCallback';
import { TakeControl } from '@/components/TakeControl';
import { Page404 } from '@/components';
import Register from '@/modules/register/Register.vue';
import Login from '@/modules/login/Login.vue';
import extractUrlInfo from '@/modules/login/shared/utils/url-parser';

const routes = [
  { path: '/:pathMatch(.*)*', component: Page404 },
  { path: '/not-found', name: 'NotFound', component: Page404 },
  { path: '/login', component: Login, name: 'login', key: 'login' },
  { path: '/register', component: Register, name: 'register', key: 'register' },
  { path: '/register/:innerPage', redirect: '/register' },
  { path: '/auth-callback', component: AuthCallback, name: 'AuthCallback', key: 'auth-callback' },
  { path: '/take-control/:sessionId', component: TakeControl, name: 'TakeControl', key: 'take-control' },
];

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes,
});

// TODO: DGC-27954 dynamic route test
router.addRoute({
  path: '/~test',
  props: {
    title: 'register.welcome.title',
    htmlText: 'register.welcome.htmlText',
    termsText: 'register.termsText',
    content: {
      noOffering: {
        title: 'register.welcome.noOffering.title',
        htmlText: 'register.welcome.noOffering.htmlText',
      },
    },
    cookiePolicyText: 'register.cookiePolicyText',
  },
  component: () => import('@/modules/register/RegistrationPage/RegistrationPage.vue'),
  name: 'register/welcome2',
  children: [],
});

router.beforeEach((to, from, next) => {
  if (
    to.name === 'register'
    && !to.query?.linkid
  ) {
    // if linkid is missing - try to get it from link from local storage
    const registerRoute = storageService.session.get(configs.REGISTER_PATH_KEY);
    const registerRouteQuery = registerRoute.split('?')[1] || '';
    const { linkId } = extractUrlInfo(new URLSearchParams(registerRouteQuery));

    if (linkId) {
      next({ name: 'register', query: { linkid: linkId } });
    } else {
      next({ name: 'NotFound' });
    }
  }

  next();
});

export default router;
